import LegalPage from "./LegalPage";
import { TERMS_AND_CONDITIONS } from "./termsContent";

const TermsAndConditions = () => <LegalPage document={TERMS_AND_CONDITIONS} />;

export default TermsAndConditions;
